import React, { useEffect, useState } from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";
import AppButton from "../../components/button/component";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import AppTextField from "../../components/text-field/component";
import {
  isValidGuid,
  validateEmail,
  validatePassword,
} from "../../utils/validation";
import { toast } from "react-toastify";
import Guid from "guid";
import FunnelStepTypes from "../funnel-step/types";
import Facebook from "../../assets/logo/facebook.svg";
import AppleLogo from "../../assets/logo/apple.svg";
import AppleSignin from "react-apple-signin-auth";

import {
  isAllAddressCookiePresent,
  getIPConfig,
  readCookie,
  getPortalCD,
  createCookie,
} from "../../utils/helpers";
import { useDispatch } from "react-redux";
import { useGoogleLogin } from "@react-oauth/google";
import GoogleLoginLogo from "../../assets/logo/google-normal.svg";
import { trackEvents } from "../../utils/tracking-events";
import {
  AppleCliendId,
  AppleRedirectUrl,
  CAREER_PREFERENCE_TEST_ASSESSMENT_ID,
  CAREER_TEST_ASSESSMENT_ID,
  ENNEAGRAM_TEST_ASSESSMENT_ID,
  FacebookAppId,
  generateContentKey,
  PERSONALITY_TEST_ASSESSMENT_ID,
  removeWhitespace,
  ROMANTIC_COMPATIBILITY_ASSESSMENT_ID,
  wrapScoresWithTraitLevel,
} from "../../utils/general-config";
import axios from "axios";
import { FacebookProvider, LoginButton } from "react-facebook";
import Loader from "../../components/loader";
import {
  convertToLowerCase,
  getCookie,
  getCountryCode,
} from "../../utils/utility-functions";
import { traitType } from "../../services/enum/environment-enum";
import { useTranslation } from "react-i18next";
import PathHelper from "../../utils/path-helper";
import { APP_NAVIGATION, LOCALE } from "../../utils/constants";
import useSignOut from "../../utils/sign-out";
import { fetchABTestAndNavigate } from "../../utils/ab-test-helpers";
import jwtDecode from "jwt-decode";
import Footer_V2 from "../../components/footer-v2/component";

const PushUserInformationToFunnelStep = (userInformation) => ({
  type: FunnelStepTypes.SET_USERINFO,
  payload: userInformation,
});

const PushGuestUserToFunnelStep = (guestUser) => ({
  type: FunnelStepTypes.SET_GUEST_USER,
  guestUser,
});

const PushPrefillEmailFunnelStep = (prefillEmail) => {
  return {
    type: FunnelStepTypes.SET_PREFILL_EMAIL,
    prefillEmail,
  };
};
const PushDashboardAbTestValueFunnelStep = (dashboardAbTestValue) => {
  return {
    type: FunnelStepTypes.SET_DASHBOARD_AB_TEST_VALUE,
    dashboardAbTestValue,
  };
};

const LoginIQ = ({
  loginUserAndAuthenticateConnect,
  updateUserIdConnect,
  funnelStep,
  createExternalUserAccountConnect,
  updateGuestUserConnect,
  decryptUrlConnect,
  getContentLatestVersionConnect,
  getAssessmentByAssessmentIdConnect,
  getAssessmentResultByAssessmentAttemptIdConnect,
  createContentMapConnect,
  IsGuestOrPremiumUserConnect,
  getOrderDataByUserIdConnect,
  saveRelationshipCompatibilityResultConnect,
  saveUserAssessmentResultMapsConnect,
  fetchAbTestConnect,
  getAbTestConnect,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const token = getCookie("jwtToken");
  const signOut = useSignOut();
  // const token = localStorage.getItem("jwtToken");
  const queryParams = new URLSearchParams(location.search);
  const assessmentAttemptIdFromQuery =
    isValidGuid(queryParams.get("assessmentAttemptId")) &&
    queryParams.get("assessmentAttemptId");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFb, setIsLoadingFb] = useState(false);
  const [isLoadingG, setIsLoadingG] = useState(false);
  const [isLoadingApple, setIsLoadingApple] = useState(false);
  const [modelType, setModelType] = useState("");
  const [userTraits, setUserTraits] = useState([]);
  const [latestVersion, setLatestVersion] = useState("");
  const [resTraitType, setResTraitType] = useState();
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  // const dashboardAbTestValue = getCookie("dashboardAbTestValue");
  const dashboardPath = PathHelper(APP_NAVIGATION.DASHBOARD_B, currentLocale);
  const planPath = PathHelper(APP_NAVIGATION.PLAN, currentLocale);
  const parentIdFromQuery =
    isValidGuid(queryParams.get("prntid")) && queryParams.get("prntid");
  const assessmentMapIdFromQuery =
    isValidGuid(queryParams.get("assessmapid")) &&
    queryParams.get("assessmapid");

  const forgotPasswordPath = PathHelper(
    APP_NAVIGATION.FORGOT_PASSWORD,
    currentLocale,
  );
  const [isParentUserGuestOrPremium, setIsParentUserGuestOrPremium] =
    useState(false);
  const signupPath = PathHelper(APP_NAVIGATION.SINUIQ, currentLocale);
  const {
    userGUID: oldUserId,
    assessmentAttemptId,
    assessmentId,
    countryCD: reduxCountryCD,
    currencyCD,
    isAuth,
    ipAddress,
  } = funnelStep || {};
  const emailAddress = queryParams.get("gusr");
  const countryCD = getCountryCode(reduxCountryCD);
  const { t } = useTranslation();
  const isEnneagramAssessment =
    convertToLowerCase(assessmentId) ===
    convertToLowerCase(ENNEAGRAM_TEST_ASSESSMENT_ID);
  const isCareerPreferenceAssesment =
    convertToLowerCase(assessmentId) ===
    convertToLowerCase(CAREER_PREFERENCE_TEST_ASSESSMENT_ID);
  const isCareerAssessment =
    convertToLowerCase(assessmentId) ===
    convertToLowerCase(CAREER_TEST_ASSESSMENT_ID);
  const isRomanticCompatibilityTest =
    convertToLowerCase(assessmentId) ===
    convertToLowerCase(ROMANTIC_COMPATIBILITY_ASSESSMENT_ID);
  const isPersonalityTestAssessment =
    convertToLowerCase(assessmentId) ===
    convertToLowerCase(PERSONALITY_TEST_ASSESSMENT_ID);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState({
    emailError: "",
    passwordError: "",
  });

  const mappedUserTrait =
    userTraits?.length > 0 ? wrapScoresWithTraitLevel(userTraits) : [];
  const contentKey = generateContentKey(mappedUserTrait);

  useEffect(() => {
    if (!!assessmentAttemptIdFromQuery) {
      getAssessmentResultByAssessmentAttemptIdConnect(
        assessmentAttemptIdFromQuery,
      ).then((res) => {
        if (!!res) {
          setUserTraits(res?.userTraits);
          setModelType(res?.modelType);
          setResTraitType(res?.traitType);
        }
      });
    }
  }, [assessmentAttemptIdFromQuery]);

  useEffect(() => {
    if (isPersonalityTestAssessment && modelType && contentKey) {
      const data = {
        modelType: modelType,
        contentKey:
          resTraitType === traitType.OPPOSITE && isPersonalityTestAssessment
            ? contentKey
            : "",
      };
      getContentLatestVersionConnect(data).then((res) => {
        if (res) {
          setLatestVersion(res);
        }
      });
    }
  }, [
    modelType,
    contentKey,
    isEnneagramAssessment,
    resTraitType,
    getContentLatestVersionConnect,
    isPersonalityTestAssessment,
    assessmentId,
  ]);

  useEffect(() => {
    if (isAuth === true && !assessmentAttemptIdFromQuery) {
      navigate(dashboardPath.next);
      // fetchABTestAndNavigate({
      //   userGuid: oldUserId,
      //   fetchAbTestConnect,
      //   navigate,
      //   currentLocale,
      //   dispatch,
      // });
    } else if (!assessmentAttemptIdFromQuery) {
      signOut({ isNavigate: false });
    }
  }, [isAuth, assessmentAttemptIdFromQuery, dashboardPath.next]);

  useEffect(() => {
    if (!isAllAddressCookiePresent()) {
      getIPConfig(dispatch);
    }

    trackEvents("logInView", {
      userGuid: oldUserId,
      eventLabel: "Page View",
      assessmentAttemptId: assessmentAttemptId,
      assessmentId: assessmentId,
      countryCD: countryCD,
      currencyCD: currencyCD,
      portalCD: getPortalCD(currentLocale),
      visitId: readCookie("visitGuid"),
      visitorId: readCookie("visitorGuid"),
    });
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let error = "";
    if (name === "email") {
      error = validateEmail(value, t);
      dispatch(PushPrefillEmailFunnelStep(value));
    } else if (name === "password") {
      error = validatePassword(value, t);
    }
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    setError((prevError) => ({ ...prevError, [`${name}Error`]: error }));
  };
  const handleNavigateGuestUser = () => {
    // fetchABTestAndNavigate({
    //   userGuid: oldUserId,
    //   fetchAbTestConnect,
    //   navigate,
    //   currentLocale,
    //   dispatch,
    // });
    navigate(dashboardPath.next);
    dispatch(PushGuestUserToFunnelStep(true));
  };

  const handleCreateContentMap = (userGuid) => {
    if (
      isPersonalityTestAssessment &&
      userGuid &&
      contentKey &&
      modelType &&
      assessmentAttemptIdFromQuery &&
      latestVersion
    ) {
      const contentMapData = {
        userGuid,
        contentKey,
        modelType: removeWhitespace(modelType),
        assessmentAttemptId: assessmentAttemptIdFromQuery,
        version: latestVersion,
      };
      createContentMapConnect(contentMapData).then((res) => {});
    }
  };

  const handleRomanticCompatibilityResultSaving = ({ userGUID }) => {
    if (
      isRomanticCompatibilityTest &&
      parentIdFromQuery &&
      isParentUserGuestOrPremium
    ) {
      saveRelationshipCompatibilityResultConnect(assessmentMapIdFromQuery).then(
        (res) => {
          if (!!res) {
            const resultId = res.userTraits[0]?.userAssessmentResultId;
            const payloadAssessmentResultMap = [
              {
                userAssessmentResultId: resultId,
                sharedWithUserId: parentIdFromQuery,
              },
              {
                userAssessmentResultId: resultId,
                sharedWithUserId: userGUID,
              },
            ];
            saveUserAssessmentResultMapsConnect(
              payloadAssessmentResultMap,
            ).then((res) => {});
          }
        },
      );
    }
  };

  useEffect(() => {
    if (parentIdFromQuery && parentIdFromQuery !== null) {
      IsGuestOrPremiumUserConnect(parentIdFromQuery).then((res) => {
        if (res?.isPremiumOrGuestUser) {
          setIsParentUserGuestOrPremium(res?.isPremiumOrGuestUser);
          dispatch(
            PushUserInformationToFunnelStep({
              romanticCompatibilityParentUserId: parentIdFromQuery,
            }),
          );
          // createCookie(
          //   "romanticCompatibilityParentUserId",
          //   parentIdFromQuery,
          //   1
          // );
        }
      });
    }
  }, [parentIdFromQuery]);

  const handleSignin = (event) => {
    event.preventDefault();
    const { email, password } = formData;
    const isEmailError = validateEmail(email.trim(), t);
    const isPwdError = validatePassword(password.trim(), t);
    if (isEmailError.length > 0) {
      setError((prevError) => ({ ...prevError, emailError: isEmailError }));
    } else {
      setError((prevError) => ({ ...prevError, emailError: "" }));
    }
    if (isPwdError.length > 0) {
      setError((prevError) => ({ ...prevError, passwordError: isPwdError }));
    } else {
      setError((prevError) => ({ ...prevError, passwordError: "" }));
    }
    if (isEmailError.length > 0 || isPwdError.length > 0) return;

    const params = {
      Username: email.trim(),
      Password: password.trim(),
      ipAddress: ipAddress,
    };
    setIsLoading(true);
    loginUserAndAuthenticateConnect(params)
      .then((response) => {
        if (response) {
          const isUserGuidEmpty = response.parentUserGuid === Guid.EMPTY;
          const { userGuid, email, isPremium, gender } = response;
          const newUserGuid = userGuid;
          const oldUserGuid = oldUserId;
          const updateUserIdPayload = {
            oldUserGuid: oldUserGuid,
            newUserGuid: newUserGuid,
            assessmentId: assessmentId,
            assessmentAttemptId: assessmentAttemptId,
          };
          if (isUserGuidEmpty) {
            // Update Redux state immediately
            dispatch(
              PushUserInformationToFunnelStep({
                userGUID: newUserGuid,
                email: email,
                gender: gender,
              }),
            );
            if (oldUserGuid && newUserGuid) {
              updateUserIdConnect(updateUserIdPayload).then((response) => {
                if (isRomanticCompatibilityTest) {
                  setTimeout(() => {
                    // fetchABTestAndNavigate({
                    //   userGuid: userGuid,
                    //   fetchAbTestConnect,
                    //   navigate,
                    //   currentLocale,
                    //   dispatch,
                    // });
                    navigate(dashboardPath.next);
                  }, 3000);
                } else {
                  navigate(dashboardPath.next);
                  // fetchABTestAndNavigate({
                  //   userGuid: userGuid,
                  //   fetchAbTestConnect,
                  //   navigate,
                  //   currentLocale,
                  //   dispatch,
                  // });
                }
              });
            }

            // Execute these immediately after Redux state update
            handleCreateContentMap(userGuid);

            handleRomanticCompatibilityResultSaving({
              userGUID: userGuid,
            });

            // IsGuestOrPremiumUserConnect(userGuid).then((res) => {
            //   if (res?.isPremiumOrGuestUser) {
            //     getOrderDataByUserIdConnect(userGuid).then((res) => {
            //       if (res && res?.customerId) {
            //         console.log("first");
            //       }
            //     });
            //   }
            // });
          } else {
            // Update Redux state immediately for guest users too
            dispatch(
              PushUserInformationToFunnelStep({
                userGUID: newUserGuid,
                email: email,
                gender: gender,
              }),
            );

            if (emailAddress) {
              const updateGuestUserData = {
                id: response.userGuid,
                firstName: response?.firstName,
                lastName: response?.lastName,
                emailAddress: response?.email,
                invitationStatus: 1,
                parentId: response?.parentUserGuid,
              };

              updateGuestUserConnect(updateGuestUserData).then((res) => {});
              if (oldUserGuid && newUserGuid) {
                updateUserIdConnect(updateUserIdPayload).then((response) => {
                  handleNavigateGuestUser();
                });
              }
            } else {
              if (oldUserGuid && newUserGuid) {
                updateUserIdConnect(updateUserIdPayload).then((response) => {
                  if (!!response) {
                    if (isRomanticCompatibilityTest) {
                      handleRomanticCompatibilityResultSaving({
                        userGUID: newUserGuid,
                      });
                    }
                  }

                  handleNavigateGuestUser();
                });
              }
            }
          }
        } else {
          toast.error(t("login.login_error_msg"));
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Sign-in failed", error);
        if (error.response) {
          toast.error(t("login.login_error_msg"));
        } else {
          toast.error(error.message);
        }
        setIsLoading(false);
      })
      .finally(() => {
        // setIsLoading(false); // Stop loader
      });
  };

  useEffect(() => {
    if (emailAddress) {
      const token = emailAddress;
      decryptUrlConnect(token).then((res) => {
        setFormData({
          email: res?.guestUser?.emailAddress,
        });
      });
    }
  }, [emailAddress]);

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      if (emailAddress) {
        toast.error(t("login.guest_login_msg"));
        setIsLoading(false);
        return;
      }

      if (!!tokenResponse) {
        const userInfo = await axios
          .get(
            `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`,
            {
              headers: {
                Authorization: `Bearer ${tokenResponse.access_token}`,
              },
            },
          )
          .then((res) => {
            responseGoogle(res.data, tokenResponse.access_token);
          });
      } else {
        // setLoginError(true);
        // setLoginErrorMessage("Failed to login with google");
      }
    },
    onError: (errorResponse) => {
      // setLoginError(true);
      // setLoginErrorMessage("Failed to login with google");
      console.log(errorResponse);
    },
  });

  const responseGoogle = (response, accessToken) => {
    if (!!response && !!accessToken) {
      const { name, email, id } = response;
      createCookie("uname", name, 1);
      const externalData = {
        createUser: {
          countryCD: countryCD,
          currencyCD: currencyCD,
          portalCD: getPortalCD(currentLocale),
          firstName: name,
          email: email,
          password: "",
          socialLogin: "google",
        },
        externalLoginInfo: {
          loginType: 1,
          providerKey: id, // "100732998798818",
        },
      };
      setIsLoadingG(true);
      createExternalUserAccountConnect(externalData)
        .then((response) => {
          if (!!response) {
            const { isPremium, isNewUser } = response;
            if (response.isValid) {
              const { userGuid } = response;
              const newUserGuid = userGuid;
              const oldUserGuid = oldUserId;
              const updateUserIdPayload = {
                oldUserGuid: oldUserGuid,
                newUserGuid: newUserGuid,
                assessmentId: assessmentId,
                assessmentAttemptId: assessmentAttemptId,
              };
              // Update Redux state immediately
              dispatch(
                PushUserInformationToFunnelStep({
                  userGUID: newUserGuid,
                  email: email,
                  gender: null,
                }),
              );

              if (oldUserGuid && newUserGuid) {
                updateUserIdConnect(updateUserIdPayload).then((response) => {
                  navigate(dashboardPath.next);
                  // dashboard ab test
                  // if (!isNewUser) {
                  //   fetchABTestAndNavigate({
                  //     userGuid: response.userGuid,
                  //     fetchAbTestConnect,
                  //     navigate,
                  //     currentLocale,
                  //     dispatch,
                  //   });
                  // } else {
                  //   getAbTestConnect({
                  //     abTestId: DASHBOARD_AB_TEST_ID,
                  //     userGuid: userGuid,
                  //     portalCD: "IT",
                  //     visitorId: readCookie("visitorGuid"),
                  //   }).then((res) => {
                  //     if (res) {
                  //       const { caseValue } = res;
                  //       dispatch(PushDashboardAbTestValueFunnelStep(caseValue));
                  //       // createCookie("dashboardAbTestValue", caseValue, 1);
                  //     }
                  //   });
                  // }
                });
              }

              handleRomanticCompatibilityResultSaving({
                userGUID: userGuid,
              });

              handleCreateContentMap(userGuid);
            } else {
              toast.error(t(response.error && "login.email_taken_msg"));
              setIsLoading(false);
            }
          }
        })
        .catch((error) => {
          setIsLoading(false);
        })
        .finally(() => {
          // setIsLoadingG(false); // Stop loader
        });
    }
  };

  const responseApple = (response) => {
    setIsLoadingApple(true);

    try {
      const { authorization } = response;
      const { code, id_token } = authorization;
      const decodedToken = jwtDecode(id_token);

      const email = decodedToken?.email;

      const externalData = {
        createUser: {
          countryCD: countryCD,
          currencyCD: currencyCD,
          portalCD: getPortalCD(currentLocale),
          firstName: email ? email.split("@")[0] : "",
          lastName: "",
          email: email,
          password: "",
          socialLogin: "apple",
        },
        externalLoginInfo: {
          loginType: 3, // 3 represents Apple login
          providerKey: decodedToken.sub, // Use the authorization code as provider key
          idToken: id_token, // Store id_token for verification
        },
      };

      // Only proceed if we have an email
      if (!email) {
        console.error("No email received from Apple");
        toast.error(t("login.apple_login_no_email"));
        setIsLoadingApple(false);
        return;
      }

      createExternalUserAccountConnect(externalData)
        .then((response) => {
          if (response && response.isValid) {
            const { userGuid } = response;
            const newUserGuid = userGuid;
            const oldUserGuid = oldUserId;

            // Update Redux state
            dispatch(
              PushUserInformationToFunnelStep({
                userGUID: newUserGuid,
                email: email,
                gender: null,
              }),
            );

            const updateUserIdPayload = {
              oldUserGuid: oldUserGuid,
              newUserGuid: newUserGuid,
              assessmentId: assessmentId,
              assessmentAttemptId: assessmentAttemptId,
            };

            if (oldUserGuid && newUserGuid) {
              updateUserIdConnect(updateUserIdPayload)
                .then(() => {
                  trackEvents("external_login_success", {
                    assessmentId: assessmentId,
                  });
                  setIsLoadingApple(false);

                  // Handle content mapping if needed
                  handleCreateContentMap(userGuid);

                  handleRomanticCompatibilityResultSaving({
                    userGUID: userGuid,
                  });

                  fetchABTestAndNavigate({
                    fetchAbTestConnect,
                    navigate,
                    assessmentAttemptId: assessmentAttemptIdFromQuery,
                    parentIdFromQuery,
                    assessmentMapIdFromQuery,
                    currentLocale,
                  });
                })
                .catch((error) => {
                  console.error("Update user ID failed:", error);
                  setIsLoadingApple(false);
                  toast.error(t("login.login_error_msg"));
                });
            } else {
              trackEvents("external_login_success", {
                assessmentId: assessmentId,
              });
              setIsLoadingApple(false);
              fetchABTestAndNavigate({
                fetchAbTestConnect,
                navigate,
                assessmentAttemptId: assessmentAttemptIdFromQuery,
                parentIdFromQuery,
                assessmentMapIdFromQuery,
                currentLocale,
              });
            }
          } else {
            setIsLoadingApple(false);
            if (response?.error) {
              toast.error(t(response.error));
            } else {
              toast.error(t("login.apple_login_failed"));
            }
          }
        })
        .catch((error) => {
          console.error("Apple login API error:", error);
          setIsLoadingApple(false);
          toast.error(t("login.login_error_msg"));
        });
    } catch (error) {
      console.error("Apple Sign-In error:", error);
      setIsLoadingApple(false);
      toast.error(t("login.login_error_msg"));
    }
  };

  const responseFacebook = (response) => {
    if (emailAddress) {
      toast.error(t("login.guest_login_msg"));
      setIsLoading(false);
      return;
    }
    if (response.status !== "unknown") {
      const { name, accessToken } = response.authResponse;
      const graphApiUrl = `https://graph.facebook.com/me?fields=email&access_token=${accessToken}`;
      fetch(graphApiUrl)
        .then((response) => response.json())
        .then((data) => {
          const { email, id } = data;
          // Set username cookie immediately to fix header username not showing issue
          createCookie("uname", name, 1);
          const externalData = {
            createUser: {
              countryCD: countryCD,
              currencyCD: currencyCD,
              portalCD: getPortalCD(currentLocale),
              firstName: name,
              email: email,
              password: "",
              socialLogin: "facebook",
            },
            externalLoginInfo: {
              loginType: 2, // Assuming 2 represents Facebook login
              providerKey: id, // Facebook User ID
            },
          };
          setIsLoadingFb(true);
          createExternalUserAccountConnect(externalData)
            .then((response) => {
              if (!!response) {
                const { isPremium, isNewUser } = response;
                if (response.isValid) {
                  const { userGuid } = response;
                  const newUserGuid = userGuid;
                  const oldUserGuid = oldUserId;

                  // Update Redux state immediately
                  dispatch(
                    PushUserInformationToFunnelStep({
                      userGUID: newUserGuid,
                      email: email,
                      gender: null,
                    }),
                  );

                  if (oldUserGuid && newUserGuid) {
                    updateUserIdConnect(
                      oldUserGuid,
                      newUserGuid,
                      assessmentId,
                      assessmentAttemptId,
                    ).then((response) => {
                      navigate(dashboardPath.next);
                      // dashboard ab test
                      // if (!isNewUser) {
                      //   fetchABTestAndNavigate({
                      //     userGuid: response.userGuid,
                      //     fetchAbTestConnect,
                      //     navigate,
                      //     currentLocale,
                      //     dispatch,
                      //   });
                      // } else {
                      //   getAbTestConnect({
                      //     abTestId: DASHBOARD_AB_TEST_ID,
                      //     userGuid: userGuid,
                      //     portalCD: "IT",
                      //     visitorId: readCookie("visitorGuid"),
                      //   }).then((res) => {
                      //     if (res) {
                      //       const { caseValue } = res;
                      //       // createCookie("dashboardAbTestValue", caseValue, 1);
                      //       dispatch(
                      //         PushDashboardAbTestValueFunnelStep(caseValue),
                      //       );
                      //     }
                      //   });
                      // }
                    });
                  }

                  handleRomanticCompatibilityResultSaving({
                    userGUID: userGuid,
                  });

                  handleCreateContentMap(userGuid);
                } else {
                  toast.error(t(response.error && "login.email_taken_msg"));
                  setIsLoading(false);
                }
              }
            })
            .catch((error) => {
              setIsLoading(false);
              console.error("Error during account creation: ", error);
            })
            .finally(() => {
              setIsLoadingFb(false); // Stop loader
            });

          // Use the email address here
        })
        .catch((error) => console.error("Error fetching email: ", error));
    } else {
      console.error(t("login.log_fn_err_msg"));
    }
  };
  function handleError(error) {
    console.log(error);
  }
  const params = new URLSearchParams({
    assessmentAttemptId:
      assessmentAttemptIdFromQuery || assessmentAttemptId || "",
  });

  if (isRomanticCompatibilityTest && parentIdFromQuery) {
    params.set("prntid", parentIdFromQuery);
    if (assessmentMapIdFromQuery) {
      params.set("assessmapid", assessmentMapIdFromQuery);
    }
  }

  return (
    <div className="min-h-screen flex flex-col bg-surface-card">
      <Header />

      <div className="flex-1 overflow-y-auto">
        <div className="min-h-full flex justify-center px-5 py-8 sm:py-10">
          <div className="w-full max-w-[430px] flex flex-col justify-center">
            <Loader
              isLoading={
                isLoading || isLoadingFb || isLoadingG || isLoadingApple
              }
            />

            {/* Login Header */}
            <div className="text-center mb-7">
              <h1 className="font-bold text-text-dark text-[32px] sm:text-[36px] leading-[1.15] tracking-[-0.02em] mb-3">
                {t("account.login_text")}
              </h1>
            </div>

            {/* Social Login Buttons */}
            <div className="flex flex-col gap-3">
              <FacebookProvider appId={FacebookAppId}>
                <LoginButton
                  id="login-facebook-button"
                  className="!w-full !h-[46px] !rounded-[12px] !bg-insightful-blue !border-0 !flex !items-center !justify-center !gap-3 !text-white !font-bold !text-[16px]"
                  scope="email"
                  onError={handleError}
                  onSuccess={responseFacebook}
                  cssclass="my-facebook-button-class"
                  icon="fa-brands fa-facebook"
                >
                  <div className="bg-white rounded-full w-[24px] h-[24px] flex items-center justify-center p-1">
                    <img
                      src={Facebook}
                      alt="Facebook"
                      className="w-full h-full object-contain"
                    />
                  </div>

                  {t("account.login_facebook_cta")}
                </LoginButton>
              </FacebookProvider>

              <button
                id="login-google-button"
                type="button"
                className="w-full h-[46px] rounded-[12px] bg-white border border-border-default flex items-center justify-center gap-3 text-text-dark font-bold text-[16px] transition hover:bg-[#FAFAFA]"
                onClick={googleLogin}
              >
                <div className="w-[24px] h-[24px] flex items-center justify-center">
                  <img
                    src={GoogleLoginLogo}
                    alt="Google"
                    className="w-[20px] h-[20px] object-contain"
                  />
                </div>

                <span>{t("account.login_google_cta")}</span>
              </button>

              {/* Apple Login Button */}
              <AppleSignin
                authOptions={{
                  clientId: AppleCliendId,
                  scope: "name email",
                  redirectURI: AppleRedirectUrl,
                  nonce: "nonce",
                  usePopup: true,
                }}
                uiType="dark"
                className="apple-signin-button"
                noDefaultStyle={true}
                onSuccess={responseApple}
                onError={(error) => {
                  console.error("Apple Sign-In error:", error);

                  setIsLoadingApple(false);

                  // Don't show error toast for user cancellation
                  if (error?.error !== "popup_closed_by_user") {
                    handleError();
                  }
                }}
                skipScript={false}
                render={(props) => (
                  <button
                    {...props}
                    id="login-apple-button"
                    type="button"
                    className="w-full h-[46px] rounded-[12px] bg-black border border-black flex items-center justify-center gap-3 text-white font-bold text-[16px] transition hover:bg-[#171717]"
                    disabled={isLoadingApple}
                    onClick={(e) => {
                      if (props.onClick) {
                        props.onClick(e);
                      }
                    }}
                  >
                    <div className="w-[24px] h-[24px] flex items-center justify-center">
                      <img
                        src={AppleLogo}
                        alt="Apple"
                        className="w-[22px] h-[22px]"
                      />
                    </div>

                    <span>{t("account.login_apple_cta")}</span>
                  </button>
                )}
              />
            </div>

            {/* OR Divider */}
            <div className="flex items-center gap-3 my-7">
              <div className="flex-1 h-px bg-divider-bar" />

              <span className="text-[13px] font-medium text-[#A49C96] whitespace-nowrap">
                {t("confirmation_iq.or_text_iq")}
              </span>

              <div className="flex-1 h-px bg-divider-bar" />
            </div>

            {/* Login Form */}
            <div className="w-full">
              <form
                className="w-full flex flex-col gap-4"
                onSubmit={handleSignin}
              >
                <AppTextField
                  id="login-email-input"
                  label={t("confirmation_iq.email_label_iq")}
                  name="email"
                  onChange={handleInputChange}
                  value={formData.email}
                  error={error.emailError}
                  placeholder={t("confirmation_iq.email_placholder_iq")}
                  inputClassName="focus:border-insightful-dark-orange focus:ring-2 focus:ring-insightful-dark-orange/20 "
                  readOnly={emailAddress ? true : false}
                />

                <AppTextField
                  id="login-password-input"
                  label={t("account.password_label")}
                  name="password"
                  onChange={handleInputChange}
                  value={formData.password}
                  error={error.passwordError}
                  type="password"
                  inputClassName="focus:border-insightful-dark-orange focus:ring-2 focus:ring-insightful-dark-orange/20 "
                  placeholder={t("account.password_placeholder")}
                />

                {/* Remember Me / Forgot Password */}
                <div className="flex justify-between items-center mt-0.5">
                  <div className="flex items-center">
                    <input
                      id="login-remember-checkbox"
                      type="checkbox"
                      name="remember"
                      className="h-4 w-4 text-insightful-purple border-[#D8D2CE] rounded focus:ring-insightful-purple"
                    />

                    <label
                      htmlFor="login-remember-checkbox"
                      className="ml-2 text-[13px] font-medium text-insightful-gray"
                    >
                      {t("account.remember_me")}
                    </label>
                  </div>

                  <Link
                    id="login-forgot-password-link"
                    to={`${forgotPasswordPath.next}?${params.toString()}&from=login-iq`}
                    className="text-[13px] font-medium text-insightful-purple hover:underline"
                  >
                    {t("account.forgot_password")}
                  </Link>
                </div>

                {/* Login Button */}
                <AppButton
                  id="login-submit-button"
                  type="submit"
                  className="!w-full !h-[50px] !rounded-[12px] !bg-[#FF8568] hover:!bg-insightful-orange !text-white !font-bold !text-[16px] !border-0 !shadow-none focus:!outline-none focus:!ring-2 focus:!ring-[#FE6634]/30"
                >
                  {t("account.login_cta")}
                </AppButton>
              </form>
            </div>

            {/* Signup Section */}
            <div className="text-center mt-6 mb-5">
              <p className="text-[14px] sm:text-[15px] font-normal text-insightful-black">
                {t("account.dont_have_account")}&nbsp;
                <Link
                  id="login-signup-link"
                  to={`${signupPath.next}?${params.toString()}`}
                  className="font-semibold text-insightful-dark-orange underline"
                >
                  {t("account.signup_text")}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer_V2 />
    </div>
  );
};

export default LoginIQ;
